import { featureFlagKey } from "@redotech/feature-flags-model/keys";

export const SupportFlagKey = {
  OMS_AGENT_SUPPORT: featureFlagKey("oms-agent-support"), // Enable OMS agent in merchant support triage
  CUSTOMER_SUGGESTIONS: featureFlagKey("customer-suggestions"), // Enable customer suggestions in support conversations
  SUPPORT_HELPDESK_V2: featureFlagKey("support-helpdesk-v-2"), // Enable support helpdesk v2 sidebar navigation
  GORGIAS_ESCALATION_INTEGRATION: featureFlagKey(
    "gorgias-escalation-integration",
  ), // Gate the Gorgias private-app onboarding card in support channel settings (default OFF until rollout)
  RICHPANEL_ESCALATION_INTEGRATION: featureFlagKey(
    "richpanel-escalation-integration",
  ), // Gate the Richpanel private-app onboarding card in support channel settings (default OFF until rollout)
  SUPPORT_HUMAN_QUEUE: featureFlagKey("support-human-queue"), // Gate Recover SMS/iMessage inbound replies onto the SupportV2 channel-inbound pipeline + human queue rollout
  ASK_REDO_SLACK: featureFlagKey("ask-redo-slack"), // Enable fresh Ask Redo orchestration in mapped merchant Slack channels
  ASK_REDO_EMERGENCY_MODE: featureFlagKey("ask-redo-emergency-mode"), // System kill switch: bypass Ask Redo and route merchants directly to the team
} as const;
